(() => {
  "use strict";

  const CUSTOM_ELEMENT_NAME = "complementary-related-products";
  const API_TEMPLATE_SELECTOR = "[data-api-related-template]";
  const PRODUCT_ITEM_SELECTOR = "[data-grid-item]";
  const RELATED_SECTION_SELECTOR = "[data-related-section]";

  const ATTR_LIMIT = "data-limit";
  const ATTR_PRODUCT_ID = "data-product-id";
  const ATTR_LAYOUT = "data-layout";
  const ATTR_INTENT = "data-intent";

  const HIDDEN_CLASS = "hidden";
  const MOBILE_SLIDER_CLASS = "grid--mobile-slider";
  const SLIDER_CLASS = "grid--slider";

  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.relatedItems = 0;
    }

    connectedCallback() {
      this.loadRelatedProducts();
    }

    loadRelatedProducts() {
      const relatedSection = this.querySelector(RELATED_SECTION_SELECTOR);

      if (!relatedSection) {
        this.updateVisibility();
        return;
      }

      const productId = relatedSection.getAttribute(ATTR_PRODUCT_ID);
      const limit = relatedSection.getAttribute(ATTR_LIMIT);
      const intent = relatedSection.getAttribute(ATTR_INTENT) || "related";
      const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=${intent}`;

      fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => this.handleRelatedProductsResponse(responseText, relatedSection))
        .catch(() => {
          this.hideSection(relatedSection);
          this.updateVisibility();
        });
    }

    handleRelatedProductsResponse(responseText, relatedSection) {
      const parsedResponse = new DOMParser().parseFromString(responseText, "text/html");
      const template = parsedResponse.querySelector(API_TEMPLATE_SELECTOR);

      if (!template) {
        this.hideSection(relatedSection);
        this.updateVisibility();
        return;
      }

      const container = document.createElement("div");
      container.innerHTML = template.innerHTML;

      const itemsCount = container.querySelectorAll(PRODUCT_ITEM_SELECTOR).length;

      if (itemsCount > 0) {
        relatedSection.innerHTML = container.innerHTML;
        this.relatedItems = itemsCount;

        const columnsMobile = parseInt(relatedSection.style.getPropertyValue("--COLUMNS-MOBILE"), 10);
        const productGridItem = relatedSection.querySelector(PRODUCT_ITEM_SELECTOR);

        if (productGridItem) {
          if (columnsMobile === 0) {
            productGridItem.parentElement.classList.add(MOBILE_SLIDER_CLASS);
          }

          if (relatedSection.getAttribute(ATTR_LAYOUT) === "slider") {
            productGridItem.parentElement.classList.add(SLIDER_CLASS);
          } else {
            productGridItem.parentElement.classList.remove(SLIDER_CLASS);
          }
        }
      } else {
        this.hideSection(relatedSection);
      }

      this.updateVisibility();
    }

    hideSection(section) {
      section.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: true }));
    }

    updateVisibility() {
      const shouldHide = this.relatedItems < 1;
      this.classList.toggle(HIDDEN_CLASS, shouldHide);
    }
  }

  if (!customElements.get(CUSTOM_ELEMENT_NAME)) {
    customElements.define(CUSTOM_ELEMENT_NAME, RelatedProducts);
  }
})();
